/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable arrow-body-style */
import { config } from '@abyss/web/tools/config';
import { ajax } from '@src/common/ajax';
import { ApiUrl } from '@src/common/ajax/apiUrl';
import { PublishRequest } from '@src/common/logging/publishNessEvent';
import { isClient } from '@src/common/util/isClient';
import { RouteUrl } from '@src/common/util/routeUrl';
import hotkeys from 'hotkeys-js';

const isLocal = config('APP_ENV') === 'local';
const maelstromLogoutUrl = config('LOG_BACK_IN_URL')!;

if (isClient()) {
  hotkeys('f5,ctrl+r,command+r', (event) => {
    // Prevent the default refresh event
    event.preventDefault();
    console.log('Ignoring Refresh window!');
  });
}

export async function logoutAndRedirect() {
  await logout(getManualLogoutNessInfo());
}

export async function onSessionTimeout() {
  await logout(getTimeoutLogoutNessInfo());
}

async function logout(nessInfo: Partial<PublishRequest>) {
  if (!isLocal) {
    await logoutApi(nessInfo);
    await logoutMaelstrom();
  }
  window.location.href = `${RouteUrl.logout}?c=${new Date().getTime()}`;
  /**
   *  TODO: for now we'll turn this off as we need the EIS team to investigate this logout functionality further
   *  const url = 'https://maelstrom-cloud.optum.com/api/identity/logout';
   *  // @ts-ignore
   *  window.open(url);
   *
   */
}

async function logoutApi(nessOptions: Partial<PublishRequest>) {
  const query = `mutation Logout($nessOptions: JSON!) {
    logout(nessOptions: $nessOptions)
  }`;
  const operationName = 'Logout';
  const body = JSON.stringify({
    operationName,
    query,
    variables: {
      nessOptions,
    },
  });
  const { success, payload } = await ajax({}, ApiUrl.apiLogout(), { body });
  console.log(success ? 'Successfully sent log to NESS' : payload);
}

async function logoutMaelstrom() {
  const { success, payload } = await ajax({}, maelstromLogoutUrl, {
    method: 'get',
    redirect: 'follow',
    credentials: 'include',
    mode: 'no-cors',
  });
  if (!success) {
    console.error('Failed to call Maelstrom logout endpoint', payload);
  }
}

function getManualLogoutNessInfo(): Partial<PublishRequest> {
  return {
    tags: ['UI', 'logout'],
    additionalFields: {
      'user-invoked': true,
      auto: false,
    },
  };
}

function getTimeoutLogoutNessInfo() {
  const nessInfo = getManualLogoutNessInfo();
  nessInfo.tags! = [...nessInfo.tags!, 'session', 'timeout'];
  nessInfo.additionalFields = {
    'user-invoked': false,
    session: 'timeout',
    auto: true,
  };
  return nessInfo;
}
